import { defineMessages } from 'react-intl';

export const disclaimerMessages = defineMessages({
  eligibility: {
    id: 'NoCardEntry.ComposeTeam.eligibility',
    defaultMessage:
      'Considering the eligibility requirements for Sorare Pro 24/25 competitions, the first player you select will influence what other players will be suggested to you, so that your team can always be entered in at least one competition',
  },
  leaderboardSelection: {
    id: 'NoCardEntry.ComposeTeam.disclaimer',
    defaultMessage:
      'Once you have selected all your players, you will be able to select the competition in which your lineup will enter, subject to the eligibility criteria.',
  },
  captain: {
    id: 'NoCardEntry.ComposeTeam.captainDisclaimer',
    defaultMessage:
      'If there is a captain bonus in the competition your team will be submitted into, Sorare will select as captain the player with the highest player score based on the last Game Week.',
  },
});
